import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

/**
 * Composant ConnectionStatus
 * Affiche un indicateur de connexion Internet
 */
const ConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowStatus(true);
      
      // Masquer après 3 secondes
      setTimeout(() => setShowStatus(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowStatus(true);
      // Garder visible tant qu'offline
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Afficher au chargement si offline
    if (!navigator.onLine) {
      setShowStatus(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showStatus) return null;

  return (
    <div className={`fixed top-4 right-4 z-50 animate-slide-in ${
      isOnline ? 'bg-green-500' : 'bg-red-500'
    } text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2`}>
      {isOnline ? (
        <>
          <Wifi size={20} />
          <span className="font-medium">Connexion rétablie</span>
        </>
      ) : (
        <>
          <WifiOff size={20} />
          <span className="font-medium">Hors ligne</span>
        </>
      )}
    </div>
  );
};

export default ConnectionStatus;
